import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Grid,
  Paper
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { getDieselRate, setDieselRate, DEFAULT_DIESEL_RATE } from '../utils/settings';

export default function Settings() {
  const [dieselRate, setDieselRateInput] = useState(String(getDieselRate()));
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    setDieselRateInput(String(getDieselRate()));
  }, []);

  const handleSave = (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');

    try {
      const saved = setDieselRate(dieselRate);
      setDieselRateInput(String(saved));
      setSuccessMsg(`Diesel rate saved as ₹${saved} per liter.`);
      setTimeout(() => setSuccessMsg(''), 3000);
    } catch (err) {
      setErrorMsg(err.message || 'Failed to save diesel rate.');
    }
  };

  const handleResetDefault = () => {
    setDieselRateInput(String(DEFAULT_DIESEL_RATE));
    setErrorMsg('');
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Settings
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Manage application rates used in Trip Entry calculations.
      </Typography>

      {successMsg && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {successMsg}
        </Alert>
      )}
      {errorMsg && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMsg}
        </Alert>
      )}

      <Paper variant="outlined" sx={{ p: 3, maxWidth: 520 }}>
        <Typography variant="h6" gutterBottom>
          Diesel Rate
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          This rate is used to auto-calculate Diesel Amount when Diesel Qty is entered
          (Diesel Amount = Diesel Qty × Rate). You can still edit Diesel Amount manually.
        </Typography>

        <form onSubmit={handleSave}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={8}>
              <TextField
                label="Diesel Rate (₹ per liter)"
                type="number"
                value={dieselRate}
                onChange={(e) => setDieselRateInput(e.target.value)}
                fullWidth
                required
                inputProps={{ min: 0.01, step: 0.01 }}
                helperText={`Default: ₹${DEFAULT_DIESEL_RATE}`}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Button
                type="submit"
                variant="contained"
                startIcon={<SaveIcon />}
                fullWidth
                sx={{ height: 56 }}
              >
                Save
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button variant="text" onClick={handleResetDefault}>
                Reset to default (₹{DEFAULT_DIESEL_RATE})
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
}
